import React from 'react';
import PropTypes from 'prop-types';

import { bemGenerator } from '@prisjakt/ui-base';
import SubmitButton from '../../../components/submit-button';

import './index.scss';

const styles = bemGenerator('cancel-or-save', ['cancel']);

const CancelOrSave = props => (
  <div className={styles.block}>
    <button type="button" className={styles.cancel} onClick={props.onCancel}>
      {props.cancelButtonText}
    </button>
    <SubmitButton
      loading={props.showLoader}
      onClick={props.onSave}
      disabled={props.saveButtonDisabled}
      text={props.saveButtonText}
    />
  </div>
);

CancelOrSave.propTypes = {
  showLoader: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  saveButtonText: PropTypes.string.isRequired,
  saveButtonDisabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
};

CancelOrSave.defaultProps = {
  showLoader: false,
  saveButtonDisabled: false,
};

export default CancelOrSave;
